// Best-effort, verification-free decode of a JWT payload. Used only for
// client-side conveniences (prefilled form fields, userId) — the backend
// always re-validates the token itself.
export function decodeJwtPayload(token) {
  try {
    const [, payloadB64] = String(token).split('.')
    return JSON.parse(atob(payloadB64.replace(/-/g, '+').replace(/_/g, '/')))
  } catch {
    return null
  }
}

// First non-empty string among the given claim names. Different RDrive token
// versions have used different claim names, so callers pass a fallback chain.
export function pickClaim(payload, names) {
  if (!payload) return ''
  for (const n of names) {
    const v = payload[n]
    if (typeof v === 'string' && v.trim()) return v.trim()
  }
  return ''
}
